export const TOWNS = [
  { name: "Corpus Christi", coords: [27.8006, -97.3964] },
  { name: "Portland", coords: [27.8773, -97.3239] },
  { name: "Ingleside", coords: [27.8778, -97.2114] },
  { name: "Calallen", coords: [27.8550, -97.6250] },
  { name: "Flour Bluff", coords: [27.6650, -97.2958] },
  { name: "Kingsville", coords: [27.5159, -97.8561] },
  { name: "Alice", coords: [27.7523, -98.0698] },
  { name: "Robstown", coords: [27.7903, -97.6689] },
  { name: "Port Aransas", coords: [27.8339, -97.0611] },
  { name: "Rockport", coords: [28.0206, -97.0547] },
  { name: "Aransas Pass", coords: [27.9095, -97.1500] },
  { name: "Mustang Island", coords: [27.7200, -97.1300] },
  { name: "North Padre Island", coords: [27.6100, -97.2150] },
  { name: "North Beach", coords: [27.8170, -97.3910] },
];
